import { exec } from "@kakaopay-common/payweb-core";
import { Device, Version } from "@kakaopay-common/user-agent";
import { INTERFACE, ERROR_CODE, NONE_INDENTIFIER } from "../../constants.mjs";
const isIos = Device.isIos();
const osVersion = Device.getOsVersion();
const isEnablePolyfill = isIos && osVersion && Version.isGreaterThanOrEqualTo(osVersion, "16") && Version.isLessThan(osVersion, "16.2");
function scrollBounces(enabled) {
  if (Device.isAndroid()) {
    return Promise.resolve({
      command: INTERFACE.SCROLL_BOUNCES,
      success: false,
      error: {
        code: ERROR_CODE.NOT_SUPPORT_OS
      },
      extras: { identifier: NONE_INDENTIFIER }
    });
  }
  if (isEnablePolyfill) {
    const $html = window.document.documentElement;
    $html.style.setProperty("overscroll-behavior", enabled ? "auto" : "none");
  }
  const command = {
    command: INTERFACE.SCROLL_BOUNCES,
    parameters: {
      enabled
    }
  };
  return exec(command);
}
function enableScrollBounces() {
  return scrollBounces(true);
}
function disableScrollBounces() {
  return scrollBounces(false);
}
export {
  disableScrollBounces,
  enableScrollBounces,
  scrollBounces
};
